// Utilitarios de mascara para formatacao de campos

/**
 * Mascara de CNPJ: 00.000.000/0000-00
 */
export function maskCNPJ(value: string): string {
  const numbers = value.replace(/\D/g, "").slice(0, 14);
  return numbers
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

/**
 * Mascara de CEP: 00000-000
 */
export function maskCEP(value: string): string {
  const numbers = value.replace(/\D/g, "").slice(0, 8);
  return numbers.replace(/(\d{5})(\d)/, "$1-$2");
}

/**
 * Mascara de Telefone Celular: (00) 90000-0000
 */
export function maskPhone(value: string): string {
  const numbers = value.replace(/\D/g, "").slice(0, 11);

  if (!numbers) return "";
  if (numbers.length <= 2) return `(${numbers}`;
  if (numbers.length <= 7) return numbers.replace(/(\d{2})(\d{0,5})/, "($1) $2").trim();

  return numbers.replace(/(\d{2})(\d{0,5})(\d{0,4})/, (_match, ddd, prefixo, sufixo) => {
    if (!sufixo) {
      return `(${ddd}) ${prefixo}`;
    }

    return `(${ddd}) ${prefixo}-${sufixo}`;
  });
}

/**
 * Valida telefone celular brasileiro com DDD + 9 digitos
 */
export function hasCompleteMobilePhone(value: string | null | undefined): boolean {
  const numbers = `${value ?? ""}`.replace(/\D/g, "");
  return /^\d{2}9\d{8}$/.test(numbers);
}

/**
 * Mascara de CNAE: 0000-0/00
 */
export function maskCNAE(value: string): string {
  const numbers = value.replace(/\D/g, "").slice(0, 7);
  return numbers
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(\d{1})(\d{2})$/, "$1/$2");
}

/**
 * Remove mascara e retorna apenas numeros
 */
export function unmask(value: string): string {
  return value.replace(/\D/g, "");
}
